import {
  type AgentActions,
  type IAgentActionModel,
  type IAgentActionSettings,
} from 'entities/AgentActions'
import { type ChatbotErrorsList } from 'entities/Chatbot'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { AgentActionsControl, type IAgentActionsControl } from 'widgets/AgentActions'

export class ChatbotAction implements IAgentActionsControl {
  private readonly _control: AgentActionsControl

  constructor(
    model: AgentActions,
    public actionErrors: ChatbotErrorsList<IAgentActionModel, IAgentActionSettings>,
    entities: IEntitiesStore
  ) {
    this._control = new AgentActionsControl(model, entities)
  }

  get list() {
    return this._control.list
  }

  getActionStore: IAgentActionsControl['getActionStore'] = (model) =>
    this._control.getActionStore(model)

  createAction: IAgentActionsControl['createAction'] = (type) => this._control.createAction(type)

  removeAction: IAgentActionsControl['removeAction'] = (index) => this._control.removeAction(index)

  dispose: IAgentActionsControl['dispose'] = () => this._control.dispose()
}
